import { getBaseRole } from '@/helpers/customRoles';
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import { StarOutlined } from '@ant-design/icons'
import { selectProfile } from '@store/profile.reducer'
import rolesEnum from '@/constant/rolesEnum'
import { declOfNum } from '@/helpers/declOfNum'
import {
  COURSE_INDICATORS_SETTINGS_PATH,
  getNewCourseInfo,
} from '@/helpers/courseIndicators'
import cn from './index.module.css'

interface INewCourseBadge {
  order?: Record<string, any> | null
  className?: string
  compact?: boolean
  studentSummary?: boolean
}

const NewCourseBadge: FC<INewCourseBadge> = ({
  order,
  className,
  compact = false,
  studentSummary = false,
}) => {
  const info = getNewCourseInfo(order)
  // Подсказка со сроком и ссылкой на настройки — служебная, её видит только администратор
  const isAdmin = getBaseRole(useSelector(selectProfile)?.role) === rolesEnum.admin

  if (!info.isNew) return null

  const badge = (
    <span
      className={classNames(cn.badge, compact && cn.compact, isAdmin && cn.withTooltip, className)}
      tabIndex={isAdmin ? 0 : undefined}
    >
      New
      <StarOutlined
        aria-hidden="true"
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
    </span>
  )

  if (!isAdmin) return badge

  const tooltipTitle = (
    <div className={cn.tooltip}>
      <b>Новый курс</b>
      <span>
        {studentSummary
          ? 'У учащегося недавно появился новый курс или класс.'
          : 'Плашка отображается после первичной записи на курс.'}
      </span>
      {info.startDate && <span>Добавлен: {info.startDate}</span>}
      {info.endDate && <span>Плашка отображается до: {info.endDate}</span>}
      {info.remainingDays !== null && (
        <span>
          Осталось: {info.remainingDays}{' '}
          {declOfNum(info.remainingDays, ['день', 'дня', 'дней'])}
        </span>
      )}
      <a
        href={COURSE_INDICATORS_SETTINGS_PATH}
        className={cn.tooltipLink}
        onClick={(event) => event.stopPropagation()}
      >
        Настроить срок
      </a>
    </div>
  )

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0} placement="top">
      {badge}
    </Tooltip>
  )
}

export default NewCourseBadge
